import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NavService, UxService } from '~/app/core/services';
import { Link, IPage } from '~/app/open-age/core/structures';
import { RoleService } from '~/app/open-age/core/services';
import * as moment from 'moment';
import { AppointmentListComponent } from '~/app/open-age-ng/welcome/appointment-list/appointment-list.component';
import { MatAutocompleteSelectedEvent, MatDatepicker, MatCalendarCellCssClasses } from '@angular/material';
import { Practitioner } from '~/app/open-age/telepain/models/practitioner';
import { FormControl } from "@angular/forms";
import { PractitionerService } from '~/app/open-age/telepain/services/practitioner.service';
import { debounceTime, switchMap } from 'rxjs/operators';
import { ReportTypeService } from '~/app/open-age/insight/services/report-type.service';
import { DocsService } from '~/app/open-age/drive/services';
import { Appointment } from '~/app/open-age/welcome/models/appointment.model';
import { Page } from '~/app/open-age/core/models';
import { Patient } from '~/app/open-age/telepain/models/patient';
import { User } from '~/app/open-age/welcome/models/user.model';
import { PatientService } from '~/app/open-age/telepain/services/patient.service';
import { OrganizationService } from '~/app/open-age/directory/services';
import { AppointmentTypeService, OrganizationService as WelcomeOrganizationService } from "~/app/open-age/welcome/services";
import { Organization } from '~/app/open-age/directory/models';
import { AppointmentType } from '~/app/open-age/welcome/models/appointment-type.model';
import { getTimezone, Timezone } from 'countries-and-timezones';

@Component({
  selector: 'app-appointments',
  templateUrl: './appointments.component.html',
  styleUrls: ['./appointments.component.css']
})
export class AppointmentsComponent implements OnInit, OnDestroy {

  isHide = false
  isProcessing = false
  tableColumns = ['prescriber', 'patient', 'topic', 'time', 'zoomId', 'actions']
  isCurrent = true;
  page: Link;
  status: string = "scheduled"
  prescriber: string;
  patient: string;
  from: Date;
  to: Date;
  topic: string;
  topics: string[] = []
  prescriberCtrl = new FormControl();
  patientSelect: Patient;
  patients: Patient[];
  patientCtrl = new FormControl();
  prescriberSelect: Practitioner;
  practitioners: Practitioner[];
  patientsCount: number;
  topicsCount: number;
  appointmentssCount: number;
  dates: Date[]
  practices: Organization[] = []
  practice: Organization
  organizationId: string
  calendarID: string
  appointmentTypes: AppointmentType[] = []
  appointmentType: AppointmentType
  timeZones = ["Asia/Calcutta", "America/Los_Angeles"]
  timeZone: string

  @ViewChild('details')
  details: AppointmentListComponent;

  constructor(
    private navService: NavService,
    private uxService: UxService,
    private route: ActivatedRoute,
    private reportType: ReportTypeService,
    private practitionerService: PractitionerService,
    private patientService: PatientService,
    private organizationService: OrganizationService,
    private welcomeOrganizationService: WelcomeOrganizationService,
    private appointmentTypeService: AppointmentTypeService,
  ) {
    let exist = false
    for (const item of this.timeZones) {
      if (item == moment.tz.guess()) {
        exist = true
        this.timeZone = item
      }
    }
    if (!exist) {
      this.timeZones.push(moment.tz.guess())
      this.timeZone = this.timeZones[this.timeZones.length - 1]
    }
    this.prescriberCtrl.valueChanges
      .pipe(
        debounceTime(300),
        switchMap((value) => this.practitionerService.search(value ? { name: value, limit: 20 } : {}))
      )
      .subscribe((page) => {
        this.practitioners = page.items;
      });
    this.patientCtrl.valueChanges
      .pipe(
        debounceTime(300),
        switchMap((value) => this.patientService.search(value ? { name: value, limit: 20 } : { limit: 20 }))
      )
      .subscribe((page) => {
        this.patients = page.items;
      });
    this.isProcessing = true
    this.organizationService.search().subscribe(page => {
      this.practices = page.items
      this.appointmentTypeService.search().subscribe(page => {
        this.appointmentTypes = page.items
        this.isProcessing = false
      }, err => {
        this.isProcessing = false
      })
    }, err => {
      this.isProcessing = false
    })
  }

  ngOnInit() {
    this.page = this.navService.register(`/appointment/list`, this.route, (isCurrent, params) => {
      this.isCurrent = isCurrent;
      if (this.isCurrent) {
        this.setContext();
      }
    });
    this.from = null;
    this.to = null;
    this.patient = null;
    this.patientSelect = null;
    this.prescriber = null;
    this.prescriberSelect = null;
    this.topic = null
    this.status = "scheduled"
    this.refreshCount()
  }

  ngOnDestroy(): void {
    this.uxService.reset();
  }

  new() {
    this.navService.goto("/appointment/list/new")
  }

  emptyTopic() {
    this.topic = null
    this.refreshCount()
  }

  onSelect(item) {
    this.navService.goto(`/appointment/list/${item.id}`)
  }

  onViewed(item) {
    this.navService.goto(`/appointment/list/view/${item.id}`)
  }

  refresh() {
    this.details.search()
    this.refreshCount()
  }

  onRemoved() {
    this.uxService.showInfo("Deleted Succesfully")
    this.details.search()
  }

  onFromDateUpdate($event) {
    this.from = $event.value;
    if (this.to && this.to < this.from) {
      this.uxService.handleError("From date cannot be greater then to date")
      this.from = null
      return
    }
    if (this.to && moment(this.to).startOf('day').toISOString() == moment(this.from).startOf('day').toISOString()) {
      this.uxService.handleError("From date and to date cannot same")
      this.from = null
      return
    }
    this.refreshCount()
  }

  onToDateUpdate($event) {
    this.to = $event.value;
    if (this.from && this.to < this.from) {
      this.uxService.handleError("From date cannot be greater then to date")
      this.to = null
      return
    }
    if (this.from && moment(this.to).startOf('day').toISOString() == moment(this.from).startOf('day').toISOString()) {
      this.uxService.handleError("From date and to date cannot same")
      this.to = null
      return
    }
    this.refreshCount()
  }

  timeZoneChange() {

  }

  onReset() {
    this.from = null;
    this.to = null;
    this.patient = null;
    this.patientSelect = null;
    this.prescriber = null;
    this.prescriberSelect = null;
    this.topic = null
    this.status = "scheduled"
    this.practice = null
    this.organizationId = null
    this.calendarID = null
    this.appointmentTypes = []
    this.isProcessing = true
    this.appointmentTypeService.search().subscribe(page => {
      this.appointmentTypes = page.items
      this.isProcessing = false
    }, err => {
      this.isProcessing = false
    })
    this.appointmentType = null
    this.refreshCount()
    this.details.search()
  }

  setContext() {
    this.uxService.setContextMenu([{
      type: 'primary',
      title: 'NEW APPOINTMENT',
      event: () => this.new()
    }]);
  }

  practiceChange() {
    this.isProcessing = true
    this.welcomeOrganizationService.get(this.practice.code).subscribe(item => {
      this.organizationId = item.id.toString()
      this.refreshCount()
      this.appointmentTypeService.search({}).subscribe(page => {
        this.appointmentTypes = page.items
        this.isProcessing = false
      })
    })
  }

  refreshCount() {
    let params = {
      reportTypeCode: "patients-count"
    }
    if (this.prescriberSelect) {
      params['email'] = this.prescriberSelect.email
      this.prescriber = this.prescriberSelect.profile.firstName + (this.prescriberSelect.profile.middleName ? this.prescriberSelect.profile.middleName + " " : "") + this.prescriberSelect.profile.lastName
    }
    if (this.patientSelect) {
      this.patient = this.patientSelect.profile.firstName + (this.patientSelect.profile.middleName ? this.patientSelect.profile.middleName + " " : "") + this.patientSelect.profile.lastName
      params['patient'] = this.patient
    }
    if (this.from && this.to) {
      let timeZone = getTimezone(this.timeZone)

      let localOffset = moment().utcOffset()

      let utcOffset = timeZone.utcOffset

      if (moment.tz(this.from, timeZone.name).isDST()) {
        utcOffset = timeZone.dstOffset
      }

      utcOffset = (utcOffset * -1) + localOffset

      params['from'] = moment(this.from).utcOffset(utcOffset).format("YYYY-MM-DDTHH:mm:ss")
      params['till'] = moment(this.to).utcOffset(utcOffset).format("YYYY-MM-DDTHH:mm:ss")
    } else {
      if (this.status != "expired") {
        params['from'] = moment().startOf('day').toISOString();
      }
    }
    if (this.organizationId) {
      params['organization'] = this.organizationId
    }
    if (this.appointmentType) {
      params['appointmentType'] = this.appointmentType.id
    }
    if (this.status == "expired") {
      params['status'] = 'visited,closed,cancelled,failed,expired'
    } else {
      params['status'] = 'scheduled'
    }
    this.reportType.data.search(params).subscribe(page => {
      if (page.items && page.items.length) {
        this.patientsCount = page.items[0].count
        this.appointmentssCount = page.items[0].total
        this.topicsCount = page.items[0].purpose
      } else {
        this.patientsCount = 0
        this.appointmentssCount = 0
        this.topicsCount = 0
      }
    })
  }

  displayPrescriber(item?: Practitioner): string | undefined {
    if (!item) {
      return "";
    }

    if (typeof item === "string") {
      return item;
    }

    if (!item.profile) {
      return item.code;
    }
    return `${item.prefix} ${item.profile.firstName} ${item.profile.lastName}`;
  }

  onOptionSelected(event: MatAutocompleteSelectedEvent): void {
    this.prescriberSelect = event.option.value;
    this.refreshCount()
  }

  handleEmptyPrescriber(event: any) {
    if (!event.target.value || event.target.value === '') {
      this.prescriberSelect = null
      this.prescriber = null
      this.refreshCount()
    }
  }

  handleEmptyPatient(event: any) {
    if (!event.target.value || event.target.value === '') {
      this.prescriberSelect = null
      this.patient = null
      this.refreshCount()
    }
  }

  displayPatient(item?: Patient): string | undefined {
    if (!item) {
      return "";
    }

    if (typeof item === "string") {
      return item;
    }

    if (!item.profile) {
      return item.code;
    }
    return `${item.profile.prefix ? item.profile.prefix + " " : ""}${item.profile.firstName} ${item.profile.middleName ? item.profile.middleName + " " : ""}${item.profile.lastName}`;
  }

  onPatientSelected(event: MatAutocompleteSelectedEvent): void {
    this.patientSelect = event.option.value;
    this.refreshCount()
  }

}
